import type {
  MRT_ColumnDef,
  MRT_VisibilityState
} from "mantine-react-table-open";
import type {
  EnergyPriceUnits,
  EnergyRevenuesListItem
} from "../../../RevenueMonitoring.types";
import { getMarktwertColumn } from "../columns/getMarktwertColumn";

const MARKTWERT_COLUMNS = [
  { key: "monatsmarktwert_solar", shortLabel: "MW Solar" },
  { key: "monatsmarktwert_wind", shortLabel: "MW Wind" },
  { key: "jahresmarktwert_solar", shortLabel: "JW Solar" },
  { key: "jahresmarktwert_wind", shortLabel: "JW Wind" }
] as const;

interface GetMarktwertOverviewColumnGroupParams {
  columnVisibility: MRT_VisibilityState;
  applicableColumns: ReadonlyArray<string>;
  energyPriceUnit: EnergyPriceUnits;
}

export function getMarktwertOverviewColumnGroup({
  columnVisibility,
  applicableColumns,
  energyPriceUnit
}: GetMarktwertOverviewColumnGroupParams): MRT_ColumnDef<EnergyRevenuesListItem> {
  return {
    id: "marktwert_overview",
    header: "Marktwertübersicht",
    mantineTableHeadCellProps: {
      className: "column-group-header-border-left"
    },
    columns: MARKTWERT_COLUMNS.filter(({ key }) =>
      applicableColumns.includes(key)
    ).map(({ key, shortLabel }) =>
      getMarktwertColumn({
        columnName: key,
        visibilityLabel: `${shortLabel} (${energyPriceUnit})`,
        columnVisibility,
        energyPriceUnit,
        groupColumns: applicableColumns
      })
    )
  };
}
